import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import PartService from '../../../Parts/Controller/PartController';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
function BatchSerialModal({ show, onClose, onSave, type, part }) {
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [value, setValue] = useState(type === 'batch' ? part.vc_BatchNumber || '' : part.vc_SerialFormat || '');
    const [expiryDate, setExpiryDate] = useState(part.dt_ExpiryDate || getCurrentDate());
    const [prefix, setPrefix] = useState(part.vc_SerialPrefix || '');
    const [serialNumbers, setSerialNumbers] = useState([]);
    const [startNumber, setStartNumber] = useState(1);
    const [format, setFormat] = useState(`${part.vc_SerialFormat}`);
    const [numberLength, setNumberLength] = useState(5);
    useEffect(() => {
        if (type === 'serial' && part.PK_Stock_ID) {
            PartService.SerialTrackingFormat(part.PK_Stock_ID, '')
                .then(response => {
                    const lastSerial = response || '';
                    const match = lastSerial[0].vc_Serial.match(/(\D+)(\d+)/);
                    if (match) {
                        const lastPrefix = match[1];
                        const lastNumber = parseInt(match[2], 10);
                        const SerFormat = prefix + format;
                        setPrefix(lastPrefix);
                        setStartNumber(lastNumber + 1);
                        setNumberLength(match[2].length); // Preserve the zero-padding length
                        setSerialNumbers(Array.from({ length: part.vc_UnitOfSale || 1 }, (_, i) =>
                            SerFormat.replace(part.vc_SerialPrefix, lastPrefix).replace(part.vc_SerialFormat, String(lastNumber + i + 1).padStart(match[2].length, '0'))
                        ));
                    } else {
                        setSerialNumbers(Array.from({ length: part.vc_UnitOfSale || 1 }, () => ''));
                    }
                })
                .catch(error => console.error('Error fetching serial numbers:', error));
        }
    }, [type, part.PK_Stock_ID, part.vc_UnitOfSale]);

    const handleSerialChange = (e, index, newValue) => {
        e.stopPropagation();
        const updatedSerials = [...serialNumbers];
        updatedSerials[index] = newValue;
        setSerialNumbers(updatedSerials);
    };

    const handleGenerateFormat = async () => {
        const SerFormat = prefix + format;
        const match = SerFormat.match(/(\D+)(\d+)/);
        if (match) {
            const formatPrefix = match[1];
            const formatNumberLength = match[2].length;
            try {
                const SerialFormat = await PartService.SerialTrackingFormat(part.PK_Stock_ID, formatPrefix);
                let startingNumber = 1;
                if (SerialFormat.length > 0) {
                    const matchNew = SerialFormat[0].vc_Serial.match(/(\D+)(\d+)/);
                    if (matchNew) {
                        const lastNumber = parseInt(matchNew[2], 10);
                        startingNumber = lastNumber + 1;
                    }
                }
                setSerialNumbers(Array.from({ length: part.vc_UnitOfSale || 1 }, (_, i) => {
                    const currentNumber = String(startingNumber + i).padStart(formatNumberLength, '0');
                    return `${formatPrefix}${currentNumber}`;
                }));
            } catch (error) {
                console.error('Error fetching serial format:', error);
            }
        }
    };

    const handleSave = () => {
        if (serialNumbers.some(serial => serial.trim() === '')) {

            Swal.fire(
                'Error!',
                'Please fill all serial number fields before saving.',
                'error'
            );
            return;
        }
        else {
            onSave(value, expiryDate, prefix, serialNumbers);
            onClose();
        }
    };

    const handleStart = (e) => {
        e.stopPropagation();
    };
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }}>
            <div className="modal-dialog">

                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add {type === 'batch' ? 'Batch Number' : 'Serial Format'}</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">

                            {type === 'serial' ? (
                                <>
                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", marginTop: "10px" }}>
                                        <label className="col-sm-4" >Prefix:</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" value={prefix} onChange={(e) => setPrefix(e.target.value)} />
                                        </div>

                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px" }}>
                                        <label className="col-sm-4" >Serial Format:</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" value={format} onChange={(e) => setFormat(e.target.value)} />
                                        </div>

                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px" }}>
                                        <label className="col-sm-4" ></label>
                                        <div className='col-sm-6' >
                                            <button className="btn btn-secondary" style={{ padding: "5px 10px" }} onClick={handleGenerateFormat}>Generate</button>
                                        </div>
                                    </div>


                                    <div style={{ maxHeight: "50vh", overflow: "auto", "marginTop": "10px", marginLeft: "10px", marginRight: "10px" }}>
                                        <table className="table table-bordered">
                                            <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                                <tr>
                                                    <th>Serial Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {serialNumbers.map((serial, index) => (
                                                    <tr key={index}>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={serial}
                                                                onChange={(e) => handleSerialChange(e, index, e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                        <label className="col-sm-4 col-form-label">Batch Number:</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" value={value} onChange={(e) => setValue(e.target.value)} />
                                        </div>
                                    </div>


                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                        <label htmlFor="bnt_OrderNumber" className="col-sm-4 col-form-label">Expiry Date:</label>
                                        <div className="col-sm-6">
                                            <input type="date" className="form-control" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}
export default BatchSerialModal;